import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

/**
 * Gate routes by auth state + role.
 *   adminOnly: true   → only roles with backend access (super_admin, admin, staff)
 *   anyAuthed: true   → any logged-in user
 */
export default function ProtectedRoute({ children, adminOnly = false, anyAuthed = false }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading || user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center" data-testid="auth-loading">
        <div className="text-sm text-zinc-500">Loading...</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
  if (adminOnly) {
    const backendRoles = ["super_admin", "admin", "staff"];
    if (!backendRoles.includes(user.role)) return <Navigate to="/" replace />;
  }
  if (anyAuthed && !user) return <Navigate to="/login" replace />;
  return children;
}
